import { render, staticRenderFns } from "./mokaoScore.vue?vue&type=template&id=79c5c6c1&scoped=true"
import script from "./mokaoScore.vue?vue&type=script&lang=js"
export * from "./mokaoScore.vue?vue&type=script&lang=js"
import style0 from "./mokaoScore.vue?vue&type=style&index=0&id=79c5c6c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5c6c1",
  null
  
)

export default component.exports